(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-training"] && !Shopify.designMode) return;
  try {
    
  class TrainingParticipantForm extends HTMLElement {
    constructor() {
      super();
      this.formId = this.dataset.formId;
      this.form = document.getElementById(this.formId);
      this.addToCartButton = this.form?.querySelector('[data-add-to-cart]');
      this.requiredFields = this.querySelectorAll('[data-required="true"]');

      this.init();
    }

    init() {
      if (!this.form || !this.addToCartButton || this.requiredFields.length === 0) return;

      // Initial validation check
      this.validateForm();

      // Add event listeners to required fields
      this.requiredFields.forEach(field => {
        field.addEventListener('input', () => this.validateForm());
        field.addEventListener('change', () => this.validateForm());
      });
    }

    validateForm() {
      let isValid = true;

      this.requiredFields.forEach(field => {
        if (!field.value || field.value.trim() === '') {
          isValid = false;
        }
      });

      if (isValid) {
        this.addToCartButton.removeAttribute('data-validation-disabled');
        // Only remove disabled if product is available
        if (!this.addToCartButton.hasAttribute('data-sold-out')) {
          this.addToCartButton.disabled = false;
        }
      } else {
        this.addToCartButton.setAttribute('data-validation-disabled', '');
        this.addToCartButton.disabled = true;
      }
    }
  }

  if (!customElements.get('training-participant-form')) {
    customElements.define('training-participant-form', TrainingParticipantForm);
  }

  // === Variant Selector ===
  class TrainingVariantSelector {
    constructor(section) {
      this.section = section;
      const dataScript = section.querySelector('script[type="application/json"][id^="TrainingVariantData-"]');
      if (!dataScript) return;

      try {
        this.data = JSON.parse(dataScript.textContent);
      } catch (e) {
        console.error('Failed to parse variant data:', e);
        return;
      }

      this.selectedOptions = {};

      // Initialize selectedOptions from current variant
      const currentVariant = this.data.variants.find(v => v.id === this.data.currentVariantId);
      if (currentVariant) {
        currentVariant.options.forEach((val, i) => {
          this.selectedOptions[i + 1] = val;
        });
      }

      // Bind click events to all pills
      this.section.querySelectorAll('.training-product__pill').forEach(pill => {
        pill.addEventListener('click', (e) => this.handlePillClick(e));
      });
    }

    handlePillClick(event) {
      const pill = event.currentTarget;
      const position = parseInt(pill.dataset.optionPosition, 10);
      const value = pill.dataset.optionValue;

      // Update selected options map
      this.selectedOptions[position] = value;

      // Update pill active states for this option group
      const container = pill.closest('[data-variant-selector]');
      if (container) {
        container.querySelectorAll('.training-product__pill').forEach(p => {
          const isActive = p.dataset.optionValue === value &&
                           parseInt(p.dataset.optionPosition, 10) === position;
          p.classList.toggle('training-product__pill--active', isActive);
          p.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      // Find matching variant
      const matchingVariant = this.findVariant();

      if (matchingVariant) {
        this.updateVariantId(matchingVariant.id);
        this.updatePrice(matchingVariant);
        this.updateDescription(matchingVariant);
        this.updateAvailability(matchingVariant);
        this.updatePackagePillPrices();
        this.updateUrl(matchingVariant.id);
      } else {
        this.handleUnavailableVariant();
      }
    }

    findVariant() {
      return this.data.variants.find(variant => {
        return variant.options.every((optVal, index) => {
          const position = index + 1;
          return this.selectedOptions[position] === optVal;
        });
      });
    }

    updateVariantId(variantId) {
      const input = this.section.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
      if (input) input.value = variantId;
    }

    updatePrice(variant) {
      const priceBadge = this.section.querySelector('.training-product__price-badge');
      if (priceBadge) {
        priceBadge.textContent = this.formatMoney(variant.price);
      }
    }

    updateDescription(variant) {
      const descContainer = this.section.querySelector('[data-variant-description]');
      if (!descContainer) return;

      if (variant.erklaerungstext) {
        descContainer.innerHTML = this.escapeHtml(variant.erklaerungstext);
        descContainer.style.display = '';
      } else {
        descContainer.innerHTML = '';
        descContainer.style.display = 'none';
      }
    }

    updateAvailability(variant) {
      const atcButton = this.section.querySelector('[data-add-to-cart]');
      if (!atcButton) return;

      if (variant.available) {
        atcButton.removeAttribute('data-sold-out');
        // Only enable if participant form validation also passes
        if (!atcButton.hasAttribute('data-validation-disabled')) {
          atcButton.disabled = false;
        }
      } else {
        atcButton.setAttribute('data-sold-out', '');
        atcButton.disabled = true;
      }
    }

    updatePackagePillPrices() {
      // When the options (e.g. Jahrgang) change, update prices on package pills
      const packageSelector = this.section.querySelector('[data-variant-selector="package"]');
      if (!packageSelector) return;

      const packagePosition = parseInt(packageSelector.dataset.optionPosition, 10);
      const priceBadges = packageSelector.querySelectorAll('.training-product__pill--package');

      priceBadges.forEach(pill => {
        const optionValue = pill.dataset.optionValue;
        const priceBadge = pill.querySelector('[data-pill-price]');
        if (!priceBadge) return;

        // Find the variant that matches this package value + current other selections
        const matchingVariant = this.data.variants.find(variant => {
          return variant.options.every((optVal, index) => {
            const pos = index + 1;
            if (pos === packagePosition) {
              return optVal === optionValue;
            }
            return this.selectedOptions[pos] === optVal;
          });
        });

        if (matchingVariant) {
          priceBadge.textContent = this.formatMoney(matchingVariant.price);
        }
      });
    }

    updateUrl(variantId) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      history.replaceState({}, '', url.toString());
    }

    handleUnavailableVariant() {
      const atcButton = this.section.querySelector('[data-add-to-cart]');
      if (atcButton) {
        atcButton.setAttribute('data-sold-out', '');
        atcButton.disabled = true;
      }
    }

    formatMoney(cents) {
      const amount = (cents / 100).toFixed(2).replace('.', ',');
      return amount + ' \u20AC';
    }

    escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }
  }

  // Mobile carousel + Variant selector initialization
  document.addEventListener('DOMContentLoaded', () => {
    // Initialize variant selectors
    document.querySelectorAll('.training-product-section').forEach(section => {
      const jsonScript = section.querySelector('script[type="application/json"][id^="TrainingVariantData-"]');
      if (jsonScript) {
        new TrainingVariantSelector(section);
      }
    });

    // Mobile carousel
    const carousels = document.querySelectorAll('.training-product__carousel');

    carousels.forEach(carousel => {
      const track = carousel.querySelector('.training-product__carousel-track');
      const dots = carousel.querySelectorAll('.training-product__carousel-dot');

      if (!track || dots.length === 0) return;

      track.addEventListener('scroll', () => {
        const scrollLeft = track.scrollLeft;
        const slideWidth = track.offsetWidth;
        const activeIndex = Math.round(scrollLeft / slideWidth);

        dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === activeIndex);
        });
      });

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          const slideWidth = track.offsetWidth;
          track.scrollTo({ left: slideWidth * index, behavior: 'smooth' });
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teaser-cards"] && !Shopify.designMode) return;
  try {
    
  class TeaserCardsFilter {
    constructor(container) {
      this.container = container;
      this.tabs = container.querySelectorAll('[data-tabs] button');
      this.cards = container.querySelectorAll('.teaser-card[data-location]');
      this.emptyState = container.querySelector('[data-empty-state]');

      if (this.tabs.length === 0) return;

      this.init();
    }

    init() {
      this.tabs.forEach(tab => {
        tab.addEventListener('click', (e) => this.handleTabClick(e));
      });
      this.updateEmptyState();
    }

    handleTabClick(e) {
      const clickedTab = e.currentTarget;
      const location = clickedTab.dataset.location;

      this.tabs.forEach(tab => tab.classList.remove('teaser-cards__tab--active'));
      clickedTab.classList.add('teaser-cards__tab--active');

      this.filterCards(location);
      this.updateEmptyState();
    }

    filterCards(location) {
      this.cards.forEach(card => {
        const cardLocation = card.dataset.location;

        if (location === 'all' || cardLocation === location) {
          card.classList.remove('teaser-card--hidden');
        } else {
          card.classList.add('teaser-card--hidden');
        }
      });
    }

    updateEmptyState() {
      if (!this.emptyState) return;
      const visibleCount = Array.from(this.cards).filter(
        card => !card.classList.contains('teaser-card--hidden')
      ).length;
      this.emptyState.hidden = visibleCount > 0;
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.teaser-cards');
    sections.forEach(section => new TeaserCardsFilter(section));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trainer-slider"] && !Shopify.designMode) return;
  try {
    
  class TrainerSlider {
    constructor(container) {
      this.container = container;
      this.swiperContainer = container.querySelector('[data-swiper-container]');

      if (!this.swiperContainer) return;

      this.init();
    }

    init() {
      const slideCount = this.swiperContainer.querySelectorAll('.swiper-slide').length;

      // Initialize Swiper
      const swiper = new Swiper(this.swiperContainer, {
        // Rewind - jump back to start after last slide
        rewind: true,

        // Active slide starts on the left
        centeredSlides: false,

        // Slides per view - reduced for better loop performance
        slidesPerView: 1.2,
        spaceBetween: 20,

        // Breakpoints
        breakpoints: {
          640: {
            slidesPerView: 1.5,
            spaceBetween: 24,
          },
          750: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          990: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 40,
          }
        },

        // Navigation arrows
        navigation: {
          nextEl: this.container.querySelector('.trainer-swiper-button-prev'),
          prevEl: this.container.querySelector('.trainer-swiper-button-next'),
        },

        // Pagination dots
        pagination: {
          el: '.trainer-swiper-pagination',
          clickable: true,
          dynamicBullets: false,
        },

        // Speed
        speed: 600,

        // Effect
        effect: 'slide',

        // Enable touch/mouse dragging
        grabCursor: true,
        simulateTouch: true,
        touchRatio: 1,
        touchAngle: 45,
        allowTouchMove: true,

        // Watch overflow to handle edge cases
        watchOverflow: true,
      });
    }
  }

  // Initialize on page load
  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.trainer-slider');
    sections.forEach(section => new TrainerSlider(section));
  });

  // Re-initialize on Shopify section render (Theme Editor)
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.trainer-slider');
      if (section) {
        new TrainerSlider(section);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["training-events"] && !Shopify.designMode) return;
  try {
    
  class TrainingEventsFilter {
    constructor(container) {
      this.container = container;
      this.tabs = container.querySelectorAll('[data-tabs] button');
      this.cards = container.querySelectorAll('.training-event-card[data-location]');
      this.emptyState = container.querySelector('[data-empty-state]');

      this.init();
    }

    init() {
      this.tabs.forEach(tab => {
        tab.addEventListener('click', (e) => this.handleTabClick(e));
      });
      this.updateEmptyState();
    }

    handleTabClick(e) {
      const clickedTab = e.currentTarget;
      const location = clickedTab.dataset.location;

      // Update active tab
      this.tabs.forEach(tab => tab.classList.remove('training-events__tab--active'));
      clickedTab.classList.add('training-events__tab--active');

      // Filter cards
      this.filterCards(location);
      this.updateEmptyState();
    }

    filterCards(location) {
      this.cards.forEach(card => {
        const cardLocation = card.dataset.location;

        if (location === 'all' || cardLocation === location) {
          card.classList.remove('training-event-card--hidden');
        } else {
          card.classList.add('training-event-card--hidden');
        }
      });
    }

    updateEmptyState() {
      if (!this.emptyState) return;
      const visibleCount = Array.from(this.cards).filter(
        card => !card.classList.contains('training-event-card--hidden')
      ).length;
      this.emptyState.hidden = visibleCount > 0;
    }
  }

  // Initialize on page load
  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.training-events');
    sections.forEach(section => new TrainingEventsFilter(section));
  });

  } catch(e) { console.error(e); }
})();
})();
